import React from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { ResponsiveHeroImage } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryTags } from "../story-page-components/story-tags.js";
import { RelatedStories } from "../story-page-components/related-stories.js";
import { PhotoStoryCard } from "../story-page-components/photo-story-card.js";
import { DfpAd } from "../dfp-ad";
import { MetypeCommentingWidget } from "@metype/components";
import { breakpoint } from "../../../utils/breakpoint";
import { addTargetBlankToExtLinks} from "../../../utils/add-target-blank-to-extlinks";
import { altTagOfHeroImages} from "../../utils";


function PhotoStoryTemplate(props) {
  const publisherName = get(props, ['config', 'publisher-name']);
  const metypeConfig = get(props, ['config', 'theme-attributes', 'metype-config'], {});
  const cdnImage = get(props, ['config', 'cdn-image'], '');

  const StoryCards = props.story.cards.map((card, index) => {
    return <PhotoStoryCard key={card.id} card={card} story={props.story} cdn={cdnImage} />
  });
  const imageElement = breakpoint('tablet') ?
    <ResponsiveHeroImage story={props.story}
    aspectRatio={[16,9]}
    alt={altTagOfHeroImages(props.story)}
    defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
    imgParams={{auto:['format', 'compress'], fit:'max'}} /> :
    <ResponsiveHeroImage story={props.story}
    aspectRatio={[9,3]}
    alt={altTagOfHeroImages(props.story)}
    defaultWidth={480} widths={[250,480,640,960,1200]} sizes="(max-width: 500px) 98%"
    imgParams={{auto:['format', 'compress'], fit:'max'}} />;
  return <article className="blank-story">
        {
          props.story["hero-image-s3-key"] ?
          <figure className="blank-story-hero-image qt-image-16x9">
            {imageElement}
          </figure>:
          <div className="blank-story-hero-image__fallback-placeholder">
          </div>
        }
      <div className="blank-story--wrapper">
        <div className={`blank-story--content ${get(props.config, ['theme-attributes', 'language_direction']) === 'right' ? 'ltr-text' : ''}`}>
          <StoryHeaderCard story={props.story} config={props.config}/>
          {StoryCards}
          <StoryTags tags={props.story.tags} config={props.config}/>
          <div className="blank-story__aside">
            <div className="app-ad app-ad--story-mrec">
              <DfpAd adtype="Story-Mrec"/>
            </div>
            <RelatedStories story={props.story}></RelatedStories>
          </div>
        </div>
        { !props.preview && <div>
            <div className="app-ad app-ad--story-horizontal">
              <DfpAd adtype="Story-Bottom-Ad"/>
            </div>
            <div className="blank-story--metype-widget">
              { !isEmpty(metypeConfig) && <MetypeCommentingWidget
                host={metypeConfig.host}
                accountId={parseInt(metypeConfig.accountId)}
                pageURL={generateHostUrl(props.story)}
                primaryColor={metypeConfig.primaryColor}/> }
            </div>
          </div>
        }
      </div>
    </article>
}



function generateHostUrl(story = {}){
  if(global.location){
    return `${global.location.origin}/${story.slug}`;
  }
}


class PhotoStory extends React.Component {
  componentDidMount() {
    addTargetBlankToExtLinks(this.storyWrapperElement);
  }
  render() {
    return <div className="story-grid story-grid--photo" ref={(el) => this.storyWrapperElement = el}>
      <PhotoStoryTemplate {...this.props}></PhotoStoryTemplate>
    </div>
  }
}

export { PhotoStory };
